import { render, staticRenderFns } from "./result-record.vue?vue&type=template&id=7378aa30&scoped=true&"
import script from "./result-record.vue?vue&type=script&lang=js&"
export * from "./result-record.vue?vue&type=script&lang=js&"
import style0 from "./result-record.vue?vue&type=style&index=0&id=7378aa30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7378aa30",
  null
  
)

export default component.exports